import { render } from "./PageHeader.vue?vue&type=template&id=15ff71b6&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"

import "./PageHeader.vue?vue&type=style&index=0&id=15ff71b6&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ff71b6"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QColor from 'quasar/src/components/color/QColor.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QColor});
